import { BrowserRouter, Route, Routes } from 'react-router'

import AppConfig from 'apps/components/AppConfig'
import { NotFoundPage } from 'apps/pages/NotFoundPage'
import { type RouterProps } from 'apps/types'

import IntroPage from './intro/IntroPage'
import RenewalLayout from '../components/layout/RenewalLayout'
import AppProvider, { type AppProviderProps } from '../providers/AppProvider'
import CompletePage from './allowances/complete/CompletePage'
import ConfirmAllowancesPage from './allowances/confirm/ConfirmAllowancesPage'
import DependentsCoveragePage from './allowances/DependentsCoveragePage'
import QmePage from './allowances/QmePage'
import ReviewAllowancesPage from './allowances/review/ReviewAllowancesPage'
import CensusPage from './employees/census/CensusPage'
import ConfirmEligibilityPage from './employees/eligibility/ConfirmEligibilityPage'
import EligibilityPage from './employees/eligibility/EligibilityPage'
import HeadcountPage from './employees/headcount/HeadcountPage'
import WhatToExpectPage from './intro/WhatToExpectPage'
import AllowancesLayout from '../components/layout/AllowancesLayout'
import ReviewAcceptedPage from './allowances/accepted/ReviewAcceptedPage'
import EligibilityConfirmedPage from './employees/eligibility/EligibilityConfirmed'

export default function EmployerRenewalsApp ({
  employerId,
  renewalConfigId,
  hasFinalizedPricing,
  employerIsEstimatedToBeALE,
  userName,
  assetPaths,
  router: Router = BrowserRouter,
  routerProps,
}: AppProviderProps & RouterProps) {
  return (
    <AppProvider
      employerId={employerId}
      renewalConfigId={renewalConfigId}
      hasFinalizedPricing={hasFinalizedPricing}
      employerIsEstimatedToBeALE={employerIsEstimatedToBeALE}
      userName={userName}
      assetPaths={assetPaths}
    >
      <Router {...routerProps}>
        <AppConfig />
        <Routes>
          <Route path='/employers/employer_renewals' element={<RenewalLayout />}>
            <Route index element={<IntroPage />} />
            <Route path='what-to-expect' element={<WhatToExpectPage />} />
            <Route path='employees'>
              <Route path='headcount' element={<HeadcountPage />} />
              <Route path='info' element={<CensusPage />} />
              <Route path='eligibility' element={<EligibilityPage />} />
              <Route path='confirm-eligibility' element={<ConfirmEligibilityPage />} />
              <Route path='eligibility-confirmed' element={<EligibilityConfirmedPage />} />
            </Route>
            <Route path='allowances' element={<AllowancesLayout />}>
              <Route path='review' element={<ReviewAllowancesPage />} />
              <Route path='qme' element={<QmePage />} />
              <Route path='dependents-coverage' element={<DependentsCoveragePage />} />
              <Route path='confirm' element={<ConfirmAllowancesPage />} />
              <Route path='complete' element={<CompletePage />} />
              <Route path='review-accepted' element={<ReviewAcceptedPage />} />
            </Route>
            <Route path='*' element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </AppProvider>
  )
}
